import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      color: palette.text.primary,
      padding: '10px',
      borderRadius: palette.borderRadius.default,
      overflowY: 'hidden',
      height: 'auto',
      transition: '0.5s ease-in-out all',
      fontSize: '1rem'
    },
    inside: {
      background: palette.background.box,
      boxShadow: palette.shadows.boxShadow
    },
    outside: {
      backgroundImage: 'linear-gradient(180deg, #F5F5F5 0%, #F5F5F5 100%)',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top left',
      backgroundSize: '100% 45px',
      '@media (max-width: 425px)': {
        backgroundSize: '100% 65px'
      }
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      userSelect: 'none',
      paddingBottom: '10px',
      pointerEvents: 'none',
      cursor: 'pointer',
      '@media (max-width: 425px)': {
        gap: '3px'
      }
    },
    arrow: {
      color: palette.text.primary,
      width: '24px',
      height: '24px',
      transition: '0.5s ease',
      pointerEvents: 'none'
    },
    title: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      width: 'max-content',
      pointerEvents: 'none',
      '@media (max-width: 724px)': {
        fontSize: '0.8rem',
        lineHeight: '22.88px'
      },
      '@media (max-width: 425px)': {
        lineHeight: '20px',
        height: '50px'
      }
    },
    arrowon: {
      transfrom: 'rotate(0deg)'
    },
    arrowoff: {
      transform: 'rotate(180deg)'
    },
    off: {
      height: '44px',
      '@media (max-width: 425px)': {
        height: '65px'
      }
    },
    on: {
      height: 'auto',
      '@media (max-width: 768px)': {
        height: 'max-content'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
